import { render, staticRenderFns } from "./DropdownItemsDetails.vue?vue&type=template&id=6f5ca13c&"
import script from "./DropdownItemsDetails.vue?vue&type=script&lang=js&"
export * from "./DropdownItemsDetails.vue?vue&type=script&lang=js&"
import style0 from "./DropdownItemsDetails.vue?vue&type=style&index=0&id=6f5ca13c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports